
/* styles */
require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-48e8919d&scoped=true!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageForm.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageForm.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-48e8919d!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageForm.vue"),
  /* scopeId */
  "data-v-48e8919d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/partials/Order/Confirm/PageForm.vue
// module id = 636
// module chunks = 0